<template>
  <v-dialog
    v-if="selected"
    :value="dialog"
    :hide-overlay="!dialog"
    @click:outside.stop="closeDialog(true)"
    @keydown.esc="closeDialog(true)"
    persistent
    max-width="700px"
    :fullscreen="is_mobile"
    :scrollable="is_mobile"
    overlay-opacity="50"
    overlay-color="#ffffff"
    content-class="default-dialog"
    >
    <v-card class="default-dialog-card">
      <v-card-title class="dialog-title">
        <span class="headline">
          <v-icon class="toolbar-icon">mdi-account</v-icon>
          {{ lang.users.view.user }} #{{ selected.id }}
        </span>
        <v-spacer></v-spacer>
        <v-icon class="dialog-close-btn" @click="closeDialog()">mdi-close</v-icon>
      </v-card-title>
      <v-card-text class="pa-0 ma-0">
        <v-container class="view-info">
          <v-row class="pa-0 ma-0">
            <v-col cols="4" lg="3" md="3" sm="4" class="pa-0">
              <Avatar
                :photo="selected.avatar"
                :size="129"
              />
            </v-col>
            <v-col cols="8" lg="9" md="9" sm="8" class="info-col">
              <v-row>
                <v-col cols="6">
                  <v-subheader>{{ lang.users.datatable.headers.name }}</v-subheader>
                  <p>{{ selected.name }}</p>
                </v-col>
                <v-col cols="6">
                  <v-subheader>{{ lang.users.datatable.headers.login }}</v-subheader>
                  <p>{{ selected.login }}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-subheader>{{ lang.users.datatable.headers.function }}</v-subheader>
                  <v-chip :color="selected.function_color" dark>{{ selected.function_name }}</v-chip>
                </v-col>
                <v-col cols="6">
                  <v-subheader>{{ lang.users.datatable.headers.category }}</v-subheader>
                  <v-chip
                    v-if="!selected.categories || selected.categories.length === 0"
                    dark
                    class="primary"
                  >
                    {{ lang.users.datatable.headers.all }}
                  </v-chip>
                  <v-chip
                    v-else
                    v-for="cat in selected.categories"
                    :key="cat.id"
                    dark
                    class="mr-1 primary"
                  >
                    {{ cat.name }}
                  </v-chip>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-subheader>{{ lang.users.datatable.headers.action }}</v-subheader>
                  <Actions :user="selected" :hideView="true" @action="scrollHistory()" @edit="edit(selected)" />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="historic">
              <v-subheader>{{ lang.users.datatable.headers.history }}</v-subheader>
              <v-container
                class="overflow-y-auto"
                v-bar="{ preventParentScroll: true, scrollThrottle: 30 }"
              >
                <v-card
                  class="mx-auto historic-inside"
                  tile
                >
                  <v-list-item
                    v-for="(history, uhi) in selected.history"
                    :key="`H-${uhi}`"
                    class="history"
                    two-line
                  >
                    <v-list-item-icon class="history-icon">
                      <v-icon :color="getHistory(history.type).color">
                        {{ getHistory(history.type).icon }}
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content class="history-content">
                      <v-list-item-title>{{ getHistory(history.type).title }}</v-list-item-title>
                      <v-list-item-subtitle>
                        {{ history.datetime }}
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-btn small icon v-on="on">
                              <v-icon small color="grey lighten-1">mdi-information</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ history.by_name }} ({{ history.by_function }})</span>
                        </v-tooltip>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-card>
              </v-container>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="gray" text @click="closeDialog()">{{ lang.users.view.close }}</v-btn>
        <v-btn color="blue darken-1" @click="edit()" text>{{ lang.users.actions.edit }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Avatar from '@/components/users/templates/Avatar'
import Actions from './templates/Actions'

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import view from '@/mixins/defaults/view'
import users from './mixins/index'

export default {
  components: { Avatar, Actions },
  mixins: [ appdata, utils, view, users ],
  methods: {
    edit () {
      this.$emit('edit', this.selected)
    }
  }
}
</script>

<style src="@/styles/inner/view.scss" lang="scss"></style>
<style lang="scss">
#app .view-info {
  padding: 15px 15px 15px 7px;
}
.info-col {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  padding: 4px 0px;
  margin-bottom: 15px;
  #app & {
    .row {
      .col {
        padding-top: 0px !important;
        line-height: 15px;
        .v-subheader {
          padding: 0px !important;
        }
      }
    }
  }

  #app.theme--light & {
    background-color: #fcfcfc;
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 15%), 0px 2px 2px 0px rgb(0 0 0 / 7%), 0px 1px 5px 0px rgb(0 0 0 / 7%);
  }

  #app.theme--dark & {
    background-color: #535353;
  }
}
</style>